import { getPaginationOptions, TableStateType } from '@/utils/table'
import { Card, Table, Breadcrumb, Button, TabsProps, Tabs } from 'antd'
import PageContainer from '@/components/Layouts/PageContainer'
import styles from './index.module.less'
import CommonTable from './components/commonTable'
import { useMount, useSetState } from 'ahooks'
import BgContainer from '@/components/Layouts/BgContainer'

function DocumentTemplateList() {
  return (
    <BgContainer className={styles['container']}>
      <CommonTable></CommonTable>
    </BgContainer>
  )
}

export default DocumentTemplateList 